import { GetServerSideProps } from 'next';
import convertPathToBreadCrumbTitle from '../utils/convert-path-to-breadcrumb-title/convert-path-to-breadcrumb-title';
import getHostFromHeaders from '../utils/get-host-from-headers';
import { BlogListPageTemplate, BlogListPageTemplateProps } from './utils/BlogListPageTemplate';
import { getBlogListPageServerSideProps } from './utils/get-blog-list-page-server-side-props';
import { getLogger } from '@src/lib/logging/logger';
import { getDeviceTypeFromHeaders } from '@src/pages/utils/get-device-type-from-headers';
import getThemeByDomainName from '@src/pages/utils/get-theme-by-domain-name';
import resolveTagTheme from '@src/pages/utils/resolve-tag-theme';
const getPageNumber = (pageParam?: string | string[]) => {
  const page = Array.isArray(pageParam) ? pageParam[0] : pageParam;
  if (!page) {
    return 1;
  }
  const pageNumber = Number(page);
  return Number.isInteger(pageNumber) && pageNumber > 0 ? pageNumber : null;
};
const Page = (props: BlogListPageTemplateProps) => {
  return <BlogListPageTemplate {...props} data-sentry-element="BlogListPageTemplate" data-sentry-component="Page" data-sentry-source-file="index.page.tsx" />;
};
export const getServerSideProps: GetServerSideProps = async ({
  params,
  query,
  locale,
  req,
  res,
  preview = false
}) => {
  const currentPage = getPageNumber(params?.page);
  if (currentPage === null) {
    return {
      notFound: true
    };
  }
  const domain = getHostFromHeaders(req?.headers);
  const deviceType = getDeviceTypeFromHeaders(req.headers);
  const theme = getThemeByDomainName(domain);
  const tagTheme = resolveTagTheme(req.headers, theme);
  const logger = getLogger('blog-list-page', tagTheme);
  const pageReferrer = req.headers.referer || '';
  return getBlogListPageServerSideProps({
    preview,
    domain,
    tagTheme,
    logger,
    currentPage,
    deviceType,
    pageReferrer,
    loadFailureMessage: 'BLOG_LIST_PAGE_LOAD_FAILURE',
    locale,
    query,
    req,
    res,
    buildRouteData: ({
      page,
      brandConfig
    }) => {
      const {
        features: {
          blogs: {
            root
          }
        }
      } = brandConfig;
      return {
        pageData: page,
        breadcrumbsData: {
          breadcrumbTitle: convertPathToBreadCrumbTitle(root),
          path: root,
          breadcrumbsCollection: {
            items: [{
              breadcrumbTitle: 'Home',
              path: '/'
            }]
          }
        }
      };
    }
  });
};
export default Page;